var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#21A078"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.04 23.9991V27.1206C42.4 27.5889 48 29.3057 48 31.1786C48 33.0515 42.4 34.7683 35.2 35.0805V46.318H28.48V35.0805C21.28 34.7683 16 33.0515 16 31.1786C16 29.3057 21.28 27.7449 28.48 27.2767V24.1552H19.36V17.6H44.16V23.9991H35.04ZM17.76 30.3982C17.76 31.8029 24 33.0515 31.84 33.0515C39.68 33.0515 46.08 31.959 46.08 30.5543C46.08 29.3057 41.44 28.3692 35.2 28.0571V31.8029H32C31.3386 31.8029 30.72 31.7612 30.122 31.721C29.5626 31.6833 29.0213 31.6468 28.48 31.6468V28.6814V27.901C22.24 28.2132 17.76 29.1496 17.76 30.3982Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.bcfae17b4acb0e89aca413250b632e64.svg";
export { ForwardRef as ReactComponent };